<template>
  <div>
    <div class="pb-3 pt-3">
      <h5>
        <strong @click="$emit('toIndex')" style="cursor: pointer">
          <arrow-left-icon class="pb-1"/>
          Voltar para a listagem de veículos
        </strong>
      </h5>
    </div>

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Veículo</strong></h5>
      </div>
        
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-6">
            <div>
              <p><strong>Placa: </strong>{{ vehicle.plate }}</p>
            </div>
            <div>
              <p><strong>Renavam: </strong>{{ vehicle.renavam }}</p>
            </div>
            <div>
              <p><strong>Chassi: </strong>{{ vehicle.chassi }}</p>
            </div>
            <div>
              <p><strong>CPF/CNPJ: </strong>{{ vehicle.cpfCnpj | cpfCnpj }}</p>
            </div>
            <div>
              <p><strong>UF: </strong>{{ vehicle.uf }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <p><strong>Criado por: </strong>{{ vehicle.createdBy }}</p>
            </div>
            <div>
              <p><strong>Criado em: </strong>{{ vehicle.createdAt | datetime }}</p>
            </div>

            <template v-if="vehicle.updatedBy">
              <div>
                <p><strong>Atualizado por: </strong>{{ vehicle.updatedBy }}</p>
              </div>
              <div>
                <p><strong>Atualizado em: </strong>{{ vehicle.updatedAt | datetime }}</p>
              </div>
            </template>

          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <button
              v-if="$withPolicy('application', 'vehicles/insert_or_update')"
              class="btn btn-outline btn-md mr-2"
              @click="$emit('editVehicle', vehicle)"
            >
              Editar
            </button>

            <span class="vehicle-status-wrapper mr-2">
              <strong class="mr-2">Status:</strong>
              <VehicleStatusToggle :vehicle="vehicle" @request-toggle="pendingToggle = $event"/>
            </span>

            <button
              v-if="$withPolicy('application', 'vehicles/delete')"
              class="btn btn-outline-red float-right"
              @click="$emit('sendDeleteVehicle', vehicle)"
            >
              Excluir veículo
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Documentos</strong> <CrlvHint/></h5>
      </div>

      <ModalActivateCrlv v-model="crlvModal" :vehicle-ids="[vehicle.id]" @activated="loadCrlvSummary"/>

      <div class="ibox-content">
        <div class="row">
          <div v-if="crlvFailure" class="col-md-12 mb-3">
            <div class="alert text-left mb-0" :class="crlvFailure.userError ? 'alert-warning' : 'alert-danger'">
              <p class="mb-1">
                <strong>{{ crlvFailure.userError ? 'O acompanhamento falhou por um ajuste que depende de você' : 'O acompanhamento falhou por um erro do sistema' }}</strong>
              </p>
              <p class="mb-1">{{ crlvFailure.reason }} Sem cobrança.</p>
              <router-link v-if="crlvFailure.link" :to="crlvFailure.link" class="font-weight-bold">
                {{ crlvFailure.linkLabel }} →
              </router-link>
            </div>
          </div>
          <div v-if="$withPolicy('application', 'vehicles/insert_or_update') && showCrlvCapture" class="col-md-12 mb-3 crlv-capture-row">
            <CrlvCaptureToggle :vehicle="vehicleWithSummary" @request-toggle="requestCrlvToggle"/>
            <span class="crlv-capture-label">Acompanhamento automático</span>
            <p class="crlv-capture-text mb-0">{{ crlvCaptureText }}</p>
          </div>
          <div class="col-md-12 mb-2">
            <strong class="mr-2">CRLV:</strong>
            <span class="badge" :class="crlvBadge.klass" :title="crlvBadge.title">{{ crlvBadge.label }}</span>
            <small v-if="crlvBadge.countdown" class="ml-2 text-muted">{{ crlvBadge.countdown }}</small>
            <button
                v-if="crlvDocument"
                class="btn btn-primary btn-sm ml-3"
                @click="downloadCrlv"
            >
              <download-icon size="1x" class="mr-1"/>
              Baixar CRLV
            </button>
          </div>
        </div>

        <div v-if="crlvDocument && crlvDocument.status === 'processed'" class="row">
          <div class="col-md-6">
            <p v-if="crlvDocument.exercise_year"><strong>Exercício: </strong>{{ crlvDocument.exercise_year }}</p>
            <p v-if="crlvLicensing"><strong>Licenciamento: </strong>{{ crlvLicensing.status === 'up_to_date' ? 'Em dia' : `Vencido há ${crlvLicensing.years_overdue} ano(s)` }}</p>
            <p v-if="crlvDetail.brand_model"><strong>Marca/Modelo: </strong>{{ crlvDetail.brand_model }}</p>
            <p v-if="crlvDetail.color"><strong>Cor: </strong>{{ crlvDetail.color }}</p>
            <p v-if="crlvDetail.fuel"><strong>Combustível: </strong>{{ crlvDetail.fuel }}</p>
            <p v-if="crlvDetail.manufacture_year"><strong>Ano Fab/Modelo: </strong>{{ crlvDetail.manufacture_year }}/{{ crlvDetail.model_year }}</p>
          </div>
          <div class="col-md-6">
            <p v-if="crlvMarket"><strong>Valor FIPE: </strong>{{ crlvMarket.fipe_price }} <small>(ref. {{ crlvMarket.reference_month }})</small></p>
            <p v-if="crlvMarket"><strong>Modelo FIPE: </strong>{{ crlvMarket.fipe_model }}</p>
            <p v-if="crlvDetail.owner_name"><strong>Proprietário: </strong>{{ crlvDetail.owner_name }}</p>
            <p v-if="crlvDetail.issued_at"><strong>Emitido em: </strong>{{ crlvDetail.issued_at }} <small v-if="crlvDetail.issue_place">({{ crlvDetail.issue_place }})</small></p>
            <p v-if="crlvAlienation && crlvAlienation.flagged" class="crlv-alert"><strong>Restrição: </strong>{{ crlvAlienation.observations }}</p>
          </div>
        </div>
      </div>
    </div>

    <Services
      v-if="accountApps.length > 0"
      :key="`${vehicle.id}-${vehicle.updatedAt}`"
      :accountApps="accountApps"
      :vehicle="vehicle"
    />

    <ModalToggleVehicleStatus
      v-if="pendingToggle"
      :value="true"
      :vehicle="pendingToggle.vehicle"
      :action="pendingToggle.action"
      @input="pendingToggle = null"
      @confirmed="onStatusConfirmed"
    />

  </div>
</template>

<script>
  import Services from './Services.vue'
  import VehicleStatusToggle from '@/components/vehicles/VehicleStatusToggle'
  import CrlvHint from '@/components/vehicles/CrlvHint'
  import CrlvCaptureToggle from '@/components/vehicles/CrlvCaptureToggle'
  import ModalActivateCrlv from '@/components/vehicles/ModalActivateCrlv'
  import { crlvBadge, crlvCaptureActive, vehicleHasSne } from '@/utils/crlvHelp'
  import ModalToggleVehicleStatus from '@/components/vehicles/ModalToggleVehicleStatus'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import { VEHICLE_MODULES, VEHICLE_STATUS } from '@/utils/vehicleStatus'

  import { ArrowLeftIcon, DownloadIcon } from 'vue-feather-icons'

  export default {
    components: { ArrowLeftIcon, CrlvCaptureToggle, CrlvHint, DownloadIcon, ModalActivateCrlv, ModalToggleVehicleStatus, Services, VehicleStatusToggle },
    computed: {
      accountApps() {
        return this.getAccountApps.filter(aa => VEHICLE_MODULES.includes(aa.name))
      },
      crlvAlienation() {
        return (this.crlvDocument && this.crlvDocument.insights && this.crlvDocument.insights.alienation) || null
      },
      crlvBadge() {
        return crlvBadge(this.crlvSummary)
      },
      crlvFailure() {
        const capture = this.crlvSummary && this.crlvSummary.capture
        if (!capture || capture.status !== 'failed')
          return null
        const reason = capture.failure_reason || 'Motivo não informado.'
        const lower = reason.toLowerCase()
        const credential = /certificado|credencial|gov\.?br|senha|login|conta sne|não encontrado|nao encontrado/.test(lower)
        return {
          userError: capture.failure_kind === 'user',
          reason,
          link: credential ? { path: '/definitions', query: { tab: 'credential' } } : null,
          linkLabel: /não encontrado|nao encontrado|conta sne/.test(lower) ? 'Conferir credencial e vínculo no SNE' : 'Ir para Credenciais'
        }
      },
      crlvCaptureText() {
        const capture = this.crlvSummary && this.crlvSummary.capture
        if (capture && capture.status === 'requested')
          return 'Acompanhamento agendado. O documento será anexado ao longo do dia.'
        if (capture && capture.status === 'capturing')
          return 'Em acompanhamento.'
        if (capture && capture.status === 'failed')
          return 'A última tentativa falhou. Veja o motivo acima e ative de novo quando estiver resolvido.'
        if (this.crlvSummary && this.crlvSummary.document_id && this.crlvSummary.licensing_status !== 'expired')
          return 'CRLV do exercício atual já anexado.'
        return 'Ative para acompanhar o CRLV digital deste veículo automaticamente. O valor por documento é exibido antes do aceite.'
      },
      showCrlvCapture() {
        const captured = !!this.crlvSummary && !!this.crlvSummary.document_id && this.crlvSummary.licensing_status !== 'expired'
        return !captured && (vehicleHasSne(this.vehicle) || crlvCaptureActive(this.crlvSummary))
      },
      vehicleWithSummary() {
        return { ...this.vehicle, crlvSummary: this.crlvSummary }
      },
      crlvDetail() {
        return (this.crlvDocument && this.crlvDocument.detail) || {}
      },
      crlvLicensing() {
        return (this.crlvDocument && this.crlvDocument.insights && this.crlvDocument.insights.licensing) || null
      },
      crlvMarket() {
        return (this.crlvDocument && this.crlvDocument.insights && this.crlvDocument.insights.market_value) || null
      },
    },
    created() {
      this.loadCrlvDocument()
    },
    data() {
      return { crlvDocument: null, crlvModal: false, crlvSummary: null, pendingToggle: null }
    },
    methods: {
      downloadCrlv() {
        const parts = ['CRLV', this.vehicle.plate, this.vehicle.renavam, this.crlvDocument.exercise_year].filter(Boolean)
        this.axios.get(`vehicles/${this.vehicle.id}/documents/${this.crlvDocument.id}/download`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`${parts.join('_')}.pdf`, blob))
          .catch(e => this.$notify.addError(e))
      },
      loadCrlvDocument() {
        this.axios.get(`vehicles/${this.vehicle.id}/documents`)
          .then(response => this.crlvDocument = (response.data && response.data[0]) || null)
          .catch(() => {})
        this.loadCrlvSummary()
      },
      loadCrlvSummary() {
        this.axios.get('vehicle_documents/summary', { params: { vehicle_ids: [this.vehicle.id] } })
          .then(response => {
            const map = response.data || {}
            this.crlvSummary = map[this.vehicle.id] || map[String(this.vehicle.id)] || null
          })
          .catch(() => {})
      },
      requestCrlvToggle({ action }) {
        if (action === 'captured') {
          this.$notify.add('Este veículo já tem o CRLV do exercício atual.')
          return
        }

        if (action === 'activate') {
          this.crlvModal = true
          return
        }

        this.axios.delete('vehicle_crlv_captures', { data: { vehicle_ids: [this.vehicle.id] } })
          .then(response => {
            this.$notify.add((response.meta && response.meta.notice) || 'Acompanhamento de CRLV desativado')
            this.loadCrlvSummary()
          })
          .catch(e => this.$notify.addError(e))
      },
      onStatusConfirmed() {
        const { vehicle, action } = this.pendingToggle
        vehicle.entityStatusId = action === 'disable' ? VEHICLE_STATUS.DISABLED : VEHICLE_STATUS.ENABLED
        this.pendingToggle = null
      }
    },
    mixins: [GetAccountApps],
    name: 'Show',
    props: {
      vehicle: { required: true, type: Object }
    },
    watch: {
      vehicle() {
        this.loadCrlvDocument()
      }
    }
  }
</script>

<style scoped lang="scss">
  .badge-manual {
    background-color: #ede9fe;
    color: #5b21b6;
  }

  .badge-warning {
    background-color: #fef3c7;
    color: #b45309;
  }

  .crlv-capture-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 8px;
  }

  .crlv-capture-label {
    font-weight: 600;
  }

  .crlv-capture-text {
    flex-basis: 100%;
    font-size: 12px;
    color: var(--primary-text-color);
    opacity: 0.8;
  }

 .card{
    height: 100%;
  }

  p{
    color: black;
  }

  .table td{
    vertical-align: middle;
  }

  .vehicle-status-wrapper {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
  }

  .badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  .crlv-alert {
    color: #f8ac59;
  }

</style>
